/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import React, { memo, useMemo } from 'react';
import { useProjectsAnalyticsL1 } from '@jira/navigation-apps__sidebar-nav4-analytics/src/common/controllers/use-projects-analytics-l1/index.tsx';
import { MoreProjectsFlyout } from '@jira/navigation-apps__sidebar-nav4-sidebars-content-projects-more-projects/src/ui/flyout/more-projects-flyout.tsx';
import { BrowseTemplatesMenuItem } from '@jira/navigation-apps__sidebar-nav4-sidebars-content-projects-browse-templates/src/ui/index.tsx';
import { Nav4ProjectsSectionPlacement } from '@jira/growth__nav-4-projects-section/src/index.tsx';
import { MenuSection } from '@atlaskit/side-nav-items/menu-section';
import { MenuList } from '@atlaskit/side-nav-items/menu-list';
import { MenuListItem } from '@atlaskit/side-nav-items/menu-list-item';
import { useIntl, defineMessage } from '@atlassian/jira-intl';
import { expVal } from '@atlassian/jira-feature-experiments';
import { fg } from '@atlassian/jira-feature-gating';
import { Nav4Recommendations } from '@jira/navigation-apps__sidebar-nav4-sidebars-content-growth-recommendations/src/index.tsx';
import { ImportWorkMenuItem } from '@jira/navigation-apps__sidebar-nav4-sidebars-content-projects-import-work/src/ImportWorkMenuItem.tsx';

const moreProjects = defineMessage({
	id: 'navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.footer.more-projects',

	defaultMessage: 'More projects',
	description: 'Message for the more projects flyout in the projects submenu',
});

const moreProjectsGalaxiaMessage = defineMessage({
	id: 'navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.footer.more-projects-galaxia',

	defaultMessage: 'More spaces',
	description: 'Message for the more projects flyout in the projects submenu',
});

function FooterInternal({
	canCreateProject = false,
}: {
	canCreateProject?: boolean | null;
}): React.JSX.Element {
	const moreProjectsGalaxia = expVal('project-terminology-refresh', 'isEnabled', false)
		? moreProjectsGalaxiaMessage
		: moreProjects;
	const { formatMessage } = useIntl();
	const { sendMoreProjectsAnalyticsEvent } = useProjectsAnalyticsL1();
	const recommendations = useMemo(() => {
		if (!canCreateProject) {
			return null;
		}
		return fg('jsmgrowth-459_temporary_gate') ? (
			<Nav4ProjectsSectionPlacement />
		) : (
			<Nav4Recommendations />
		);
	}, [canCreateProject]);
	return (
		<MenuListItem>
			<MenuSection>
				<MenuList>
					<MoreProjectsFlyout onClick={sendMoreProjectsAnalyticsEvent}>
						{formatMessage(moreProjectsGalaxia)}
					</MoreProjectsFlyout>
					{recommendations}
					{canCreateProject &&
						expVal('jsmgrowth_547_rerun_browse_templates_in_sidenav', 'isEnabled', false) && (
							<BrowseTemplatesMenuItem />
						)}
					{canCreateProject && fg('jfind-retest-left-nav-import-killswitch') && (
						<ImportWorkMenuItem />
					)}
				</MenuList>
			</MenuSection>
		</MenuListItem>
	);
}

export const Footer: React.MemoExoticComponent<typeof FooterInternal> = memo(FooterInternal);
